import React from 'react';
import {Card as SCard} from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const matchLabels = {
  profile_first_name: 'Matched: First Name',
  profile_last_name: 'Matched: Last Name',
  composer_first_name: 'Matched: Composer First Name',
  composer_last_name: 'Matched: Composer Last Name',
  song_title: 'Matched: Song Title',
  song_cycle_title: 'Matched: Song Cycle Title',
  song_text: 'Matched: Song Text',
};

const matchColors = {
  profile_first_name: 'blue',
  profile_last_name: 'teal',
  composer_first_name: 'blue',
  composer_last_name: 'teal',
  song_title: 'green',
  song_cycle_title: 'orange',
  song_text: 'light blue',
};

export const Card = ({color, header, description, meta, id, model, extra, matchedQueries = []}) => {
  const cardHeader = !!header ? (<SCard.Header>{header}</SCard.Header>) : null;
  const cardMeta = !!meta ? (<SCard.Meta>{meta}</SCard.Meta>) : null;
  const cardDesc = !!description ? (<SCard.Description>{description}</SCard.Description>) : null;
  const link = `/${model}/${id}`;

  return (
    <SCard fluid color={color} link as="a" href={link} target="_blank" rel="noopener noreferrer">
      <SCard.Content color={color}>
        {cardHeader}
        {cardMeta}
        {cardDesc}
      </SCard.Content>
      
      {matchedQueries.length > 0 && ( <SCard.Content extra> 
        <div className="center aligned"> 
          {matchedQueries.map((match) => ( 
            <span key={match} 
                  className={`ui ${matchColors[match] || 'grey'} label`} > {matchLabels[match] || `Matched: ${match}`} </span> ))} 
        </div> 
        </SCard.Content> )} 
      {extra}
    </SCard>
  );
};
